import type { Workspace } from '../types';

/**
 * Whether the workspace has a live Instagram connection, honouring the active
 * auth method. Mirrors the backend `Workspace.has_instagram_connection()` so the
 * UI never reports an OAuth-connected account as "not connected": a Graph API
 * (official Business Login) workspace is connected when it holds a token; an
 * instagrapi workspace when it holds a stored session.
 */
export function isInstagramConnected(
  workspace: Pick<
    Workspace,
    'instagram_auth_method' | 'has_instagram_token' | 'has_instagrapi_session'
  >
): boolean {
  if (workspace.instagram_auth_method === 'graph_api') {
    return Boolean(workspace.has_instagram_token);
  }
  return Boolean(workspace.has_instagrapi_session);
}
